const LOCAL_STORAGE_PREFERRED_AUDIO_OUTPUT_KEY = 'preferredAudioOutputId';
const LOCAL_STORAGE_PREFERRED_AUDIO_OUTPUT_LABEL_KEY = 'preferredAudioOutputLabel';
const LOCAL_STORAGE_PREFERRED_AUDIO_INPUT_KEY = 'preferredMicrophoneId';
const LOCAL_STORAGE_PREFERRED_AUDIO_INPUT_LABEL_KEY = 'preferredAudioInputLabel';
const LOCAL_STORAGE_PREFERRED_VIDEO_INPUT_KEY = 'preferredCameraId';
export const getPreferredAudioOutputId = () => localStorage.getItem(LOCAL_STORAGE_PREFERRED_AUDIO_OUTPUT_KEY);
export const getPreferredAudioOutputLabel = () => localStorage.getItem(LOCAL_STORAGE_PREFERRED_AUDIO_OUTPUT_LABEL_KEY);
export const getPreferredAudioInputLabel = () => localStorage.getItem(LOCAL_STORAGE_PREFERRED_AUDIO_INPUT_LABEL_KEY);
export const getPreferredAudioInputId = () => localStorage.getItem(LOCAL_STORAGE_PREFERRED_AUDIO_INPUT_KEY);
export const getPreferredVideoInputId = () => localStorage.getItem(LOCAL_STORAGE_PREFERRED_VIDEO_INPUT_KEY);
export const setPreferredAudioOutput = (deviceId, label) => {
    localStorage.setItem(LOCAL_STORAGE_PREFERRED_AUDIO_OUTPUT_KEY, deviceId);
    localStorage.setItem(LOCAL_STORAGE_PREFERRED_AUDIO_OUTPUT_LABEL_KEY, label);
};
export const setPreferredAudioInput = (deviceId, label) => {
    localStorage.setItem(LOCAL_STORAGE_PREFERRED_AUDIO_INPUT_KEY, deviceId);
    localStorage.setItem(LOCAL_STORAGE_PREFERRED_AUDIO_INPUT_LABEL_KEY, label);
};
export const setPreferredAudioOutputId = (deviceId) => {
    localStorage.setItem(LOCAL_STORAGE_PREFERRED_AUDIO_OUTPUT_KEY, deviceId);
};
export const setPreferredAudioInputId = (deviceId) => localStorage.setItem(LOCAL_STORAGE_PREFERRED_AUDIO_INPUT_KEY, deviceId);
export const setPreferredVideoInputId = (deviceId) => localStorage.setItem(LOCAL_STORAGE_PREFERRED_VIDEO_INPUT_KEY, deviceId);
export const removePreferredAudioOutputId = () => localStorage.removeItem(LOCAL_STORAGE_PREFERRED_AUDIO_OUTPUT_KEY);
export const removePreferredAudioInputId = () => localStorage.removeItem(LOCAL_STORAGE_PREFERRED_AUDIO_INPUT_KEY);
export const removePreferredVideoInputId = () => localStorage.removeItem(LOCAL_STORAGE_PREFERRED_VIDEO_INPUT_KEY);
//# sourceMappingURL=preferred_media_devices_utils.js.map